import { render, staticRenderFns } from "./MyFrontTableComment.vue?vue&type=template&id=6a88a170&"
import script from "./MyFrontTableComment.vue?vue&type=script&lang=js&"
export * from "./MyFrontTableComment.vue?vue&type=script&lang=js&"
import style0 from "./MyFrontTableComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports